var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDefaultMobileLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 15,
    fill: "#020A58"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.8078 16.6598L10.6933 17.2714L7 15.2231V13.9922L11.8078 16.6588V16.6598ZM7 21.1679V19.937L11.2491 17.5805L12.3579 16.9651L13.4668 17.5796L12.3579 18.195L7 21.167V21.1679Z",
    fill: "#41C3D8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4668 22.1309H7V22.9999H13.4668V22.1309Z",
    fill: "#41C3D8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3255 11.8183L12.7153 10.7013L14.7591 7H15.9873L13.3265 11.8183H13.3255ZM8.82812 7H10.0563L12.4077 11.2583L13.0218 12.3696L12.4087 13.4808L11.7946 12.3696L8.82812 7Z",
    fill: "#79CBBE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.8672 7H7V13.4808H7.8672V7Z",
    fill: "#79CBBE"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1441 13.3402L19.2586 12.7286L22.9519 14.7769V16.0078L18.1441 13.3411V13.3402ZM22.9519 8.83203V10.0629L18.7028 12.4194L17.5939 13.0349L16.4851 12.4204L17.5939 11.8049L22.9519 8.83299V8.83203Z",
    fill: "#B4DDF6"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9507 7H16.4839V7.86909H22.9507V7Z",
    fill: "#B4DDF6"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6252 18.1816L17.2354 19.2986L15.1916 22.9999H13.9634L16.6242 18.1816H16.6252ZM21.1235 22.9999H19.8953L17.5439 18.7415L16.9298 17.6303L17.543 16.519L18.1571 17.6303L21.1226 22.9999H21.1235Z",
    fill: "#3A58A7"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9507 16.519H22.0835V22.9999H22.9507V16.519Z",
    fill: "#3A58A7"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4967 14.203L14.7974 13.2695C14.58 13.15 14.3072 13.2298 14.188 13.4477L13.2566 15.1507C13.1374 15.3685 13.217 15.642 13.4344 15.7614L15.1337 16.6949C15.3511 16.8143 15.6239 16.7345 15.7431 16.5167L16.6746 14.8137C16.7937 14.5958 16.7141 14.3224 16.4967 14.203Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultMobileLogo);
export default __webpack_public_path__ + "static/media/default-mobile-logo.4cf98b4cd46eecc641ab241346710b5f.svg";
export { ForwardRef as ReactComponent };